import React from 'react';
import { Input } from '@avila-tek/ui/src';
import { TPeriodForm } from '../../../models';

interface EmployeeGoalInputsProps {
  formState: TPeriodForm;
  setFormState: React.Dispatch<React.SetStateAction<TPeriodForm>>;
}

function EmployeeGoalInputs({
  formState,
  setFormState,
}: EmployeeGoalInputsProps) {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="w-full flex md:flex-row flex-col gap-5">
      <div className="w-full">
        <Input
          name="goal"
          value={formState?.target ?? ''}
          label="Objetivo de la meta"
          type="number"
          min="0"
          disabled
        />
      </div>
      <div className="w-full flex flex-col">
        <Input
          name="result"
          value={formState?.result ?? ''}
          label="Resultado del beneficiario"
          type="number"
          min="0"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default EmployeeGoalInputs;
